/**
 * AI CONTEXT
 * Purpose: pure helpers for showing a student's standout moments inside the
 * Skill History tab — group by semester, sort newest-first within a semester.
 * Used by: StudentSkillHistorySection, StudentStandoutMomentsList.
 */
import { groupBy, orderBy } from "lodash"

import { StandoutMomentConstructor } from "#customTypes/composedTypes/standoutTypes"

export const groupStandoutMomentsBySemester = (
  moments: StandoutMomentConstructor[] | undefined
): Record<string, StandoutMomentConstructor[]> => {
  const grouped = groupBy(moments ?? [], "semester")

  return Object.fromEntries(
    Object.entries(grouped).map(([semester, semesterMoments]) => [
      semester,
      orderBy(semesterMoments, "createdAt", "desc"),
    ])
  )
}

export const getSemestersWithStandoutMoments = (
  momentsBySemester: Record<string, StandoutMomentConstructor[]>
): string[] => Object.keys(momentsBySemester)
